import { ElementDetails } from "@/lib/types";
import { SlackDndProps } from "./types";

export const details = {
  name: "SlackDnd",
  description: "See your Slack focus / Do Not Disturb status at a glance",
  tags: ["Communication"],
  category: "Slack",
  grid: { default: [3, 2] },
  gridNames: { default: "Compact" },
  integrationsUsed: ["slack"],
  defaultProps: {},
} as ElementDetails<SlackDndProps>;
